import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpEvent } from '@angular/common/http';
import {
  BehaviorSubject,
  Observable,
  share,
  switchMap,
  throwError,
} from 'rxjs';
import { SHARED_ENVIRONMENT } from '@cp/shared/environment/environment.token';
import { Environment } from '@cp/shared/environment/environment.interface';
import { SharedHttpService } from '../../shared/shared-http.service';
import {
  CallCentreStatus,
  ComplianceDocument,
  ComplianceDocumentUpdateUrlHttpModel,
  ComplianceStatusHttpModel,
} from './compliance-http.models';
import { ComplianceHttpPaths } from './compliance-http.paths';

@Injectable({
  providedIn: 'root',
})
export class ComplianceHttpService extends SharedHttpService {
  private _refreshComplianceDocuments$ = new BehaviorSubject<void>(undefined);
  public complianceDocuments$ = this._refreshComplianceDocuments$.pipe(
    switchMap(() =>
      this._http.get<Array<ComplianceDocument>>(
        this._environment.apiEndpoint + ComplianceHttpPaths.complianceDocuments,
      ),
    ),
  );
  public complianceSummary$ = this._http
    .get<ComplianceStatusHttpModel>(
      this._environment.apiEndpoint + ComplianceHttpPaths.complianceSummary,
    )
    .pipe(share());
  public callCentreStatus$ = this._http.get<CallCentreStatus>(
    this._environment.apiEndpoint + ComplianceHttpPaths.callCentreStatus,
  );

  constructor(
    private _http: HttpClient,
    @Inject(SHARED_ENVIRONMENT)
    private _environment: Environment,
  ) {
    super();
  }

  public refreshComplianceDocuments(): void {
    this._refreshComplianceDocuments$.next();
  }

  public updateCompliance(compliance: FormData): Observable<HttpEvent<object>> {
    return this._http.put(
      this._environment.apiEndpoint + ComplianceHttpPaths.updateCompliance,
      compliance,
      { reportProgress: true, observe: 'events' },
    );
  }

  public downloadCertificate(id: number): Observable<Blob> {
    return this._http.get(
      this._environment.apiEndpoint +
        ComplianceHttpPaths.downloadComplianceCertificate.replace(
          '{###}',
          `${id}`,
        ),
      {
        responseType: 'blob',
      },
    );
  }

  public getWorkbookUrl(
    id: number,
  ): Observable<ComplianceDocumentUpdateUrlHttpModel> {
    return this._http.get<ComplianceDocumentUpdateUrlHttpModel>(
      this._environment.apiEndpoint +
        ComplianceHttpPaths.updateUrl.replace('{###}', `${id}`),
    );
  }
}
